import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import FrameHeadshot from './FrameHeadshot';
import FrameID from './FrameID';

//Helpers
import { dataURLtoFile } from '../../helpers/helpers';
import Compressor from 'compressorjs';

const Webcam = observer(class Webcam extends React.Component {
  constructor() {
    super();
    this.capturePhoto = this.capturePhoto.bind(this);
    this.retakePhoto = this.retakePhoto.bind(this);
    this.savePhoto = this.savePhoto.bind(this);
  }

  componentWillMount() {
    this.state = {
      captured: false,
      track: null,
      showFrame: false,
      recordFinished: false
    };
  }

  componentDidMount() {
    this.initWebcam()
  }

  componentWillUnmount() {
    this.killWebcam();
  }

  componentDidUpdate(prevProps) {
    const { webcam } = this.props;

    // Change webcam
    if(webcam !== prevProps.webcam) {
      this.initWebcam()
    }
  }

  killWebcam() {
    // Kill the camera stream on unmount
    if(this.stream && this.stream.getTracks) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }

  initWebcam() {
    const _this = this;
    const { allowCapture, disableFullScreen, webcam } = this.props;

    this.killWebcam();

    const constraints = {
      audio: false,
      video: {        
        facingMode: this.props.camera
      }
    };

    if(webcam) {
      constraints.video.deviceId = webcam;
    }

    if(!disableFullScreen) {
      constraints.width = window.innerWidth;
      constraints.height = window.innerHeight;
    }

    navigator.mediaDevices.getUserMedia(constraints)
      .then(media => {
        _this.stream = media;

        // Stream the media to the video element
        const videoEl = document.querySelector('.webcam__stream');
        videoEl.srcObject = media;
        videoEl.onloadedmetadata = function(e) {
          videoEl.play();

          // Show the frame
          _this.setState({
            showFrame: true
          });
        };

        // Get blank canvas dataUrl
        if(allowCapture) {
          const canvas = document.querySelector('.webcam__canvas');

          _this.setState({
            blankCanvas: canvas.toDataURL('image/jpg')
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  capturePhoto() {
    const _this = this;

    // Flash
    const webcam = document.querySelector('.webcam');
    webcam.className += ' webcam--flash';

    // Draw captured image to a canvas
    const canvas = document.querySelector('.webcam__canvas');
    const ctx = canvas.getContext('2d');
    this.stream = document.querySelector('.webcam__stream');
    ctx.drawImage(this.stream, 0, 0, canvas.width, canvas.height);

    // Mark the photo as captured
    _this.setState({
      captured: true
    });

    // Remove the flash
    setTimeout(function(){
      webcam.className = webcam.className.replace('webcam--flash', '');
    }, 100);

    // These two processes slow down rendering so they’re on a 200ms delay
    // so that the flash works correctly
    // setTimeout(function(){

      // Convert the photo to an image
      const photo = new Image();
      photo.src = canvas.toDataURL('image/jpg');

      // Convert image base64 to file for compression
      let photoFile = dataURLtoFile(canvas.toDataURL('image/jpg', 'student_ID_verification'));
      // New copy of photo to compress
      const compressedPhoto = new Image();

      // Compress Image for faster uploading
      new Compressor(photoFile, {
        quality: 0.6,
        maxWidth: 246,
        maxHeight: 328,
        // What type to convert file to
        convertTypes: 'image/jpeg',
        // Byte threshold to convert to jpeg (5kb)
        convertSize: 5000,

        success(result) {
          let blob = result
          var reader = new FileReader();

          reader.readAsDataURL(blob);
          reader.onloadend = function () {
          var base64String = reader.result;

          compressedPhoto.src = base64String;
            }
        }
      })

      const existingPreview = document.querySelector('.webcam__preview');

      if(existingPreview) {
        existingPreview.remove();
      }

      const preview = document.createElement('div');
      preview.className = 'webcam__preview';
      preview.style.cssText = `background-image: url(${photo.src})`;

      webcam.append(preview);

      if(photo.src !== _this.state.blankCanvas) {
        _this.props.parent.setState({
          //Set Compressed Image to state for ID verification
          [_this.props.name]: compressedPhoto
        });
  
        // Stop getting the user’s media
        if(_this.stream.srcObject) {
          const tracks = _this.stream.srcObject.getTracks();

          tracks.forEach(track => {
            track.stop();
          });
        }
      } else {
        _this.setState({
          captured: false
        });
      }
    // }, 500);
  }

  retakePhoto() {
    const canvas = document.querySelector('.webcam__canvas');
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const preview = document.querySelector('.webcam__preview');
    preview.style.cssText = '';

    this.setState({
      captured: false,
      showFrame: false
    });

    this.initWebcam();
  }

  savePhoto() {
    this.props.callback();
  }

  render() {
    const {
      allowCapture,
      allowRecord,
      onCapture,
      onAccept,
      callback,
      complete,
      completeText,
      hideTools,
      name,
      recordStart,
      recordStop,
      verifying,
      translation
    } = this.props;

    return (
      <div>
        {this.props.caption && !complete &&
          <strong className="webcam__caption">{this.props.caption}</strong>
        }

        <figure className={`webcam webcam--${this.props.camera}`}>
          {/* Only show the stream if the image hasn’t been captured yet */}
          <video className="webcam__stream"></video>

          {/* Canvas that will show the photo once it has been snapped */}
          {allowCapture &&
            <canvas
              className="webcam__canvas"
              width={this.stream && this.stream.getVideoTracks ? this.stream.getVideoTracks()[0].getSettings().width : window.innerWidth}
              height={this.stream && this.stream.getVideoTracks ? this.stream.getVideoTracks()[0].getSettings().height : window.innerHeight}
            />
          }

          {/* Frame to show where to place subject of photo */}
          {this.props.type === 'portrait' && this.state.showFrame &&
            <FrameHeadshot />
          }

          {this.props.type === 'landscape' && this.state.showFrame &&
            <FrameID />
          }

          {!hideTools && !this.state.recordFinished &&
            <div className="webcam__tools">
              {/* Take photo button */}
              {allowCapture && !this.state.captured &&
                <div className="webcam__capture--captured">
                  <button
                    className="btn"
                    onClick={() => {
                      if(onCapture) { onCapture(name); }
                      this.capturePhoto();
                    }}
                  >
                    {translation.take_photo}
                  </button>
                </div>
              }

              <div className="webcam__capture--captured">
                {/* Retake photo button */}
                {allowCapture && this.state.captured &&
                  <button
                    className="btn webcam__confirm"
                    onClick={this.retakePhoto}
                  >
                    <span>{translation.retake}</span>
                  </button>
                }

                {/* Accept photo button */}
                {allowCapture && this.state.captured &&
                  <button
                    className="btn webcam__confirm"
                    onClick={() => {
                      if(onAccept) { onAccept(name); }
                      this.savePhoto();
                    }}
                  >
                    <span>{translation.confirm}</span>
                  </button>
                }
              </div>

              {/* Start recording button */}
              {allowRecord && !this.state.captured &&
                <div className="webcam__capture--captured">
                  <button
                    className="btn"
                    onClick={() => {
                      if(recordStart) { recordStart(); }
                      this.setState({ captured: true })
                    }}
                  >
                    {translation.start_recording}
                  </button>
                </div>
              }

              {/* Finish recording button */}
              {allowRecord && this.state.captured &&
                <div className="webcam__capture--captured">
                  <button
                    className="btn"
                    onClick={() => {
                      if(recordStop) { recordStop(); }
                      this.setState({recordFinished: true});
                      if(callback) { callback(); }
                    }}
                  >
                    <span>{translation.stop_scan}</span>
                    <span className="meta">{translation.finish_recording}</span>
                  </button>
                </div>
              }
            </div>
          }

          {verifying &&
            <div className="webcam__complete">
              <div className="webcam__complete-msg">
                {complete &&
                  <span className="tally__status tally__status--alt completed" >
                    <span className="meta">Complete</span>
                  </span>
                }

                {completeText}
              </div>
            </div>
          }
        </figure>
      </div>
    );
  }
})

export default translate('Webcam')(Webcam);


// WEBPACK FOOTER //
// ./src/app/components/UserMedia/Webcam.js